export function allProfileContentEducationsCollectionJsonApi(store: ReduxStore) {
  return store?.api?.profileContentEducations || [];
}
